import React from "react";
import { styled } from "@mui/material/styles";
import { Badge, Button, IconButton, Toolbar, Typography } from "@mui/material";
import { getImageFolder } from "../Utils/utils";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Box } from "@mui/system";
import HomeIcon from "@mui/icons-material/Home";
import { useState } from "react";
import Confirmation from "./Confirmation";
import logo from "./../assets/images/logo.png";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background: "#fff",
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: "100%",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const NavbarTableOrder = (props) => {
  const {
    menuDirection,
    open,
    itemCount,
    onDrawerOpen,
    onCartClick,
    companyName,
    showLogo,
    showCompanyName,
    website,
  } = props;
  const [confirmPopUp, setConfirmPopUp] = useState(false);
  const handleNavigation = () => {
    window.location.href =
      website.includes("https://") || website.includes("http://")
        ? website
        : `https://${website}`;
  };

  return (
    <AppBar position="sticky" open={open}>
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {menuDirection == "Left" ? (
            <Button
              onClick={onDrawerOpen}
              startIcon={<MenuIcon color="primary" />}
              sx={{
                height: "64px",
                display: open ? "none  !important" : "inline-flex",
              }}
            >
              Menu
            </Button>
          ) : null}

          {showLogo == "1" ? (
            <img
              //src={`${getImageFolder()}/images/logo.png` || logo}
              src={logo}
              onClick={() => window.location.reload()}
              alt={companyName}
              style={{
                objectFit: "fill",
              }}
              height="40px"
              // width="50px"
              onError={(e) => {
                e.target.style.display = "none";
                const element = document.getElementById("title");
                element.style.display = "block";
              }}
            />
          ) : null}

          {showCompanyName == "1" ? (
            <Typography
              id="title"
              variant="h6"
              noWrap
              component="div"
              onClick={() => window.location.reload()}
              sx={{
                display: {
                  xs: "none !important",
                  sm: "none !important",
                  md: "block !important",
                },
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              {companyName}
            </Typography>
          ) : null}
        </Box>
        <Box sx={{ display: "flex" }}>
          <Button
            variant="outlined"
            onClick={() => setConfirmPopUp(true)}
            sx={{
              marginRight: "8px",
              display: {
                xs: open ? "none  !important" : "block",
                sm: open ? "none  !important" : "block",
                md: "block",
              },
              fontSize: { xs: "0.675rem", md: "1rem" },
            }}
          >
            Home page
          </Button>
          <Badge
            badgeContent={itemCount}
            color="primary"
            onClick={() => onCartClick()}
            sx={{ display: { xs: "block", lg: "none" } }}
          >
            <ShoppingCartIcon
              fontSize="large"
              color="primary"
              onClick={() => onCartClick()}
            />
          </Badge>
        </Box>
      </Toolbar>
      {confirmPopUp ? (
        <Confirmation
          title="Confirm"
          message="Are you sure you want to navigate to home page.Your cart will be lost"
          onClose={() => setConfirmPopUp(false)}
          confirmPopUp={confirmPopUp}
          handleNavigation={handleNavigation}
        />
      ) : null}
    </AppBar>
  );
};
